<template>
  <div
    class="autocomplete-item"
    :title="data.label"
  >
    {{ data.label }}
    <a
      href="#"
      title="Clear"
      class="autocomplete-item__clear"
      @click.prevent="$emit('clear', data.id)"
    >
      Clear
    </a>
  </div>
</template>

<script>
export default {
  name: 'autocomplete-item',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClickOutside() {
      this.isOpen = false;
    },
    onBlur() {},
    onChange() {
      this.isOpen = true;
      this.filterResults();
    },
    filterResults() {
      if (this.search === '') {
        this.results = this.items;
      }
      this.results = this.availableResults.filter(item => {
        const str = typeof item === 'string' ? item : Object.values(item).join(' ');
        return str.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },
    onSelect(item) {
      this.$emit('add', item);
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.autocomplete-item {
  height: 28px;
  border-radius: 14px;
  padding: 4px 33px 4px 11px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  position: relative;
  background: #8fb6f5;
  color: #32325a;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  &__clear {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    font-size: 0;
    line-height: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: currentColor;
    transition: background-color 0.15s ease-in-out;
    .no-touchevents &:hover {
      background-color: #fff;
    }
    &:active {
      background-color: #fff;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      background: currentColor;
      left: 50%;
      width: 11px;
      height: 2px;
    }
    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
}
</style>
